export const VIEW_FIELD_KEYS = {
	REFUND_STATUS: 'refund',
	REFUND_REASON: 'reason',
	REFUND_SUGGESTION: 'refundSuggestion',
	WARNING: 'warning',
	IS_LENIENT_REFUND: 'isLenientRefund',
	LENIENCY_REFUND_REASON: 'leniencyRefundReason',
	IS_INSTANT_RS_YES_REFUND: 'isInstantRSYesRefund',
	INSTANT_RS_YES_REFUND_REASON: 'instantRSYesRefundReason',
	REFUND_SUGGESTION_RULE_SET_USED: 'refundSuggestionRuleSetUsed',
	REFUND_TYPE: 'refundType'
};

export const ACTION_BUTTONS_ID = {
	CREATE_TOURNAMENT_REFUND_REQUEST: 'createTournamentRefundRequest'
};

export const NOT_AVAILABLE: string = 'Not available';
